import { render, staticRenderFns } from "./customRadioDate.vue?vue&type=template&id=0c490262"
import script from "./customRadioDate.vue?vue&type=script&lang=js"
export * from "./customRadioDate.vue?vue&type=script&lang=js"
import style0 from "./customRadioDate.vue?vue&type=style&index=0&id=0c490262&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports